import axios from 'axios';
import { modules } from 'src/store';

export async function init({ rootState, commit, dispatch }) {
	if (!rootState.auth.currentUser.isAdmin) return;

	dispatch('getUsers');
	commit('INIT');
}

export async function reset({ commit }) {
	commit('RESET');
}

export async function getUsers({ commit }) {
	const { data } = await axios.get('/super/users', { root: true });
	commit('SET_USERS', data);
}

export async function login({ commit, dispatch, state }) {
	const userId = state.user && state.user.ID;
	if (!userId) return;
	commit('LOGIN', userId);
	try {
		await Promise.all(
			modules.map(m => dispatch(`${m}/init`, null, { root: true }))
		);
	} catch (error) {
		console.error(error);
	}
}

export async function logout({ commit, dispatch }) {
	commit('LOGOUT');
	try {
		await Promise.all(
			modules.map(m => dispatch(`${m}/init`, null, { root: true }))
		);
	} catch (error) {
		console.error(error);
	}
}

export async function getUser({ commit, dispatch }, userId) {
	const { data: user } = await axios.get(`/super/${userId}`, { root: true });
	commit('SET_USER', user);

	if (!user || !user.ID) return;

	dispatch('getExternal');
	dispatch('getSubscriptions');
	dispatch('getDatasource');
}

export async function getExternal({ commit, state }) {
	const userId = state.user && state.user.ID;
	if (!userId) return;
	const { data } = await axios.get(`/super/${userId}/external`, { root: true });
	commit('SET_EXTERNAL', data);
}

export async function getDatasource({ commit, state }) {
	const userId = state.user && state.user.ID;
	if (!userId) return;
	try {
		commit('UPDATE_DATASOURCE', null);
		const { data } = await axios.get(`/super/${userId}/datasource`, { root: true });
		commit('UPDATE_DATASOURCE', data);
	} catch (error) {
		if (!error.handled) {
			if (error.response.status !== 404) {
				throw error;
			}

			commit('UPDATE_DATASOURCE', {
				type: 'no_datasource',
			});
		}
	}
}

export async function updateUser({ commit, state }, data) {
	const userId = state.user && state.user.ID;
	if (!userId) return;
	await axios.put(`/super/${userId}`, data, { root: true });
	commit('UPDATE_USER', data);
}

export async function getFacebookSystemUserToken() {
	const { data } = await axios.get('/super/facebookSystemUserToken', { root: true });
	return data;
}

export async function updateFacebook({ commit, state }, data) {
	const userId = state.user && state.user.ID;
	if (!userId) return;
	data.userId = userId;
	await axios.post('/super/updateFacebook', data, { root: true });
	commit('UPDATE_USER', {
		fbPageId: data.pageId,
	});
}

export async function getSubscriptions({ commit, state }) {
	commit('SET_SUBSCRIPTIONS', null);
	const userId = state.user && state.user.ID;
	if (!userId) return;
	const { data } = await axios.get(`/super/${userId}/subscriptions`, { root: true });
	commit('SET_SUBSCRIPTIONS', data);
}

export async function createSubscription({ dispatch, state }, subscription) {
	const userId = state.user && state.user.ID;
	if (!userId) return;
	await axios.post(`/super/${userId}/subscription`, subscription, { root: true });
	return dispatch('getSubscriptions');
}
